import { TextField } from "@material-ui/core";
import React, { Component, useState } from "react";
import { Col, Container, Image, Modal, Row, Table } from "react-bootstrap";
import BasicPagination from "../../Pagination/Pagination";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { ReferralTableBody } from "./Tables/ReferralTableBody";
import ReferralTableMobile from "./ReferralTableMobile";
import { ReferralTableHeader } from "./Tables/ReferralTableHeader";
import Media from "react-media";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { get_vendor_referrals } from "../../../store/actions/vendorReferrals/vendorreferralsactions";
import Accordion from "react-bootstrap/Accordion";
import { logOutUser } from "../../../store/actions/authAction";

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import NoContent from "../../reusableComponents/NoContentComponent";

class VendorReferrals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      pageNo: 1,
      start: 0,
      end: 10,
      referralcode: "",
    };
  }
  componentDidMount() {
    const token = this.props.auth.user.accessToken;
    this.props.get_vendor_referrals(token);
    const referralcode = this.props.auth.user.VendorUser.referral_code;
    this.setState({
      referrals: this.props.referrals ? this.props.referrals : [],
      referralcode: referralcode,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.referrals &&
      this.state.referrals.length !== nextProps.referrals &&
      nextProps.referrals.length
    ) {
      this.setState({ referrals: nextProps.referrals });
    }
  }
  renderTableDataBody = () => {
    const referralsData = this.state.referrals;
    const { start, end } = this.state;
    return (
      <React.Fragment>
        {referralsData.slice(start, end).map((data) => (
          <ReferralTableBody
            data={data}
            refuserId={data._id}
            refree={{
              src: data?.referred_id?.profile_photo.length
                ? data?.referred_id?.profile_photo[0]
                : "",
              name: data.name,
            }}
            referalcode={data.referee_id.referral_code}
            referalRole={data.referred_id_Model}
            refDate={new Date(data.createdAt)}
            enrollDate={new Date(data.enroll_date)}
            lastActivity={data.last_activity}
            referralQualified={data.referral_qualified ? "Yes" : "No"}
            amount="₹ -"
            receivingOrgID="-"
            receivingOrgName="-"
          />
        ))}
      </React.Fragment>
    );
  };

  referralTableMobileView = () => {
    const referralsData = this.state?.referrals;
    const { start, end } = this.state;
    return (
      <React.Fragment>
        {referralsData?.length ? referralsData?.slice(start, end)?.map((data, index) => (
          <ReferralTableMobile indexKey={index} item={data} />
        )) : <NoContent />}
      </React.Fragment>
    );
  };

  handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    this.setState({ start: calcStart, end: pageNo * 10, pageNo: pageNo });
  };

  render() {
    console.log(this.props);
    return (
      <React.Fragment>
        <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                displayButton="refferal"
                RefferalButton={
                  <>
                    <ReferralCode referralcode={this.state.referralcode} />
                  </>
                }
                // RefferalButton={ <button
                //   //onClick={(e) => history.push("/additemavailablity")}
                //   // onClick={() => addNewItem()}
                //   className="btn add_button_custom_1"
                // >
                //   + Add Item
                // </button>}
                newButton={true}
              />
              <Container fluid>
                <div className="super-admin-inside-right-side-panel">
                  <div className="seating_dashboard_top_new_header">
                    <div className="row">
                      <div className="col-6">
                        <Media query="(min-width: 992px)">
                          <h4>My Referrals</h4>
                        </Media>
                        <Media query="(max-width: 992px)">
                          <h5 style={{ paddingBottom: "15px" }}>
                            My Referrals
                          </h5>
                        </Media>
                      </div>
                      <Media query="(min-width: 992px)">
                        <div className="col-6 text-right">
                          <ReferralCode
                            referralcode={this.state.referralcode}
                          />
                        </div>
                      </Media>
                    </div>
                  </div>
                  <div>
                    <Row>
                      <Col md={4}>
                        <TextField
                          type="search"
                          variant="outlined"
                          label="Search"
                        />
                      </Col>
                    </Row>
                  </div>
                  <Media query="(min-width: 992px)">
                    <div
                      className={`col-12 p-0 user-table-reusable-superadmin`}
                    >
                      <Table>
                        <thead>
                          <ReferralTableHeader
                            headOne={
                              <>
                                Referral <br />
                                ID
                              </>
                            }
                            headTwo={
                              <>
                                Referral <br />
                                Code
                              </>
                            }
                            headThree={
                              <>
                                Referee <br />
                                User ID
                              </>
                            }
                            headFour={
                              <>
                                Referee <br />
                                Name
                              </>
                            }
                            headFive={
                              <>
                                Referee <br />
                                Role
                              </>
                            }
                            headSix={
                              <>
                                Referred <br />
                                Date
                              </>
                            }
                            headSeven={
                              <>
                                Qualifying <br />
                                Activity
                              </>
                            }
                            headEight={
                              <>
                                Referral <br />
                                Qualified
                              </>
                            }
                            headNine={
                              <>
                                Qualifying Activity <br />
                                Date
                              </>
                            }
                            selectedTab={2}
                          // headTen={
                          //   <>
                          //     Receiving Org <br />
                          //     Name
                          //   </>
                          // }
                          />
                        </thead>
                        <tbody>{this.renderTableDataBody()}</tbody>
                      </Table>
                    </div>
                  </Media>

                  {/*******************************
                   *  @DESC Pending Mobile View
                   *******************************/}
                  <Media query="(max-width: 991px)">
                    <>
                      <div className="row seating-dashboard-table">
                        <div className="col-3 mpr-1">
                          <p className="f10-500">
                            Refereed
                            <br /> User ID
                          </p>
                        </div>
                        <div className="col-3  mpr-1">
                          <p className="f10-500">
                            Referred
                            <br /> User Name
                          </p>
                        </div>
                        <div className="col-3 mpl-1">
                          <p className="f10-500">
                            Referred
                            <br /> Role
                          </p>
                        </div>
                        <div className="col-3 mpl-1">
                          <p className="f10-500">
                            Referred
                            <br /> Date
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 p-0">
                          <Accordion>
                            {this.referralTableMobileView()}
                          </Accordion>
                        </div>
                      </div>
                    </>
                  </Media>
                  <BasicPagination
                    totalRecords={this.state.referrals.length}
                    limit={50}
                    batch={this.state.page}
                    onBatchChange={(e) => this.handleBatchChange(e)}
                  />
                </div>
              </Container>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

// export default VendorReferrals;
const ShareButton = (props) => {
  return (
    <div
      style={{
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        boxShadow: "0px 5px 10px #91919133",
        padding: "10px",
      }}
    >
      <Image src={props.image} />
    </div>
  );
};
const ReferralCode = (props) => {
  const [open, setOpen] = React.useState(false);
  const openModal = () => {
    if (open) {
      setShare(false);
    }
    setOpen(!open);
  };
  const [state, setState] = useState(0);
  const [share, setShare] = useState(false);
  const vendorUrl = `https://devvendor.amealio.in/signup?referralCode=${props.referralcode}`;
  const copyUrl = (copy) => {
    var value = copy;
    var tempInput = document.createElement("input");
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  };
  return (
    <React.Fragment>
      <div>
        <Media query="(min-width: 992px)">
          <button onClick={openModal} className="btn add_button_custom_1">
            View Referral Code
          </button>
        </Media>
        <Media query="(max-width: 992px)">
          <button
            onClick={openModal}
            className="btn add_button_custom_1"
            style={{ fontSize: "10px" }}
          >
            View Referral Code
          </button>
        </Media>
        <Modal show={open} onHide={openModal} centered>
          <Modal.Header className="py-0 pt-3 border-0" closeButton>
            <Modal.Title className="f18-700">
              {share ? "Share Your Referral Code" : "My Referral Code"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pr-0 pl-0">
            {share ? (
              <div className="m-0 p-2">
                <div className="f12-400">
                  You can share your referral code using the following:
                </div>
                <div className="mt-2 d-flex">
                  <EmailShareButton size={32} round={true} url={vendorUrl}>
                    <ShareButton
                      image={require("../../../assets/images/ReferalIcons/gmail.svg")}
                    />
                  </EmailShareButton>
                  <EmailShareButton size={32} round={true} url={vendorUrl}>
                    <ShareButton
                      image={require("../../../assets/images/ReferalIcons/chat.svg")}
                    />
                  </EmailShareButton>
                  <WhatsappShareButton size={32} round={true} url={vendorUrl}>
                    <ShareButton
                      image={require("../../../assets/images/ReferalIcons/whatsapp.svg")}
                    />
                  </WhatsappShareButton>
                  <div
                    onClick={() => copyUrl(vendorUrl)}
                    style={{ cursor: "pointer" }}
                  >
                    <center>
                      <ShareButton
                        image={require("../../../assets/images/ReferalIcons/copy red.svg")}
                      />
                    </center>
                  </div>
                </div>
                <>
                  <div className="f12-400 mt-3">Using Social Media</div>
                  <div className="mt-2 d-flex">
                    <FacebookShareButton size={32} round={true} url={vendorUrl}>
                      <ShareButton
                        image={require("../../../assets/images/ReferalIcons/facebook.svg")}
                      />
                    </FacebookShareButton>
                    <TwitterShareButton size={32} round={true} url={vendorUrl}>
                      <ShareButton
                        image={require("../../../assets/images/ReferalIcons/twitter.svg")}
                      />
                    </TwitterShareButton>
                  </div>
                </>
              </div>
            ) : (
              <>
                <Row className="m-0 p-2">
                  <Col xs={8}>
                    <div className="d-flex justify-content-between">
                      <div
                        className={`f12-700 mr-3 navigation-tab-top-referrals ${state === 0 && `navigation-tab-top-referrals-selected`
                          }`}
                        onClick={() => {
                          setState(0);
                        }}
                      >
                        Invite your Customer
                      </div>
                      <div
                        className={`f12-700 navigation-tab-top-referrals ${state === 1 && `navigation-tab-top-referrals-selected`
                          }`}
                        onClick={() => {
                          setState(1);
                        }}
                      >
                        Invite other Business
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="m-0 p-4">
                  <h4>
                    {state === 0
                      ? "Invite your Customer"
                      : "Invite other Business"}
                  </h4>
                  <div className="mt-4 f14-400">
                    We are trying to get more places onboard with us to serve
                    you better
                  </div>
                </div>
                <div style={{ background: "#FFF9E8 " }} className="m-0 p-4">
                  <Row>
                    <Col md={2}>
                      <div
                        // style={{ borderRadius: "50%", backgroundColor: "#ffffff" }}
                        className="p-2"
                      >
                        <Image
                          src={require("../../../assets/images/Icon/Group 57728.svg")}
                        />
                      </div>
                    </Col>
                    <Col md={8}>
                      <h5>Your Referral Code</h5>
                      <h4>{props.referralcode}</h4>
                    </Col>
                    <Col md={2} align="right">
                      <div className="d-flex p-2 ">
                        <div
                          className="mr-2"
                          style={{
                            background: "white",
                            borderRadius: "50%",
                            boxShadow: "0px 2px 9px #00000017",
                            padding: "3px",
                          }}
                          onClick={() => {
                            setShare(true);
                          }}
                        >
                          <Image
                            src={require("../../../assets/images/Icon/share.svg")}
                            width="20px"
                          />
                        </div>
                        <div
                          style={{
                            background: "white",
                            borderRadius: "50%",
                            boxShadow: "0px 2px 9px #00000017",
                            padding: "3px",
                          }}
                          onClick={() => copyUrl(props.referralcode)}
                        >
                          <i
                            className="fa fa-copy"
                            style={{ color: "#EE3A23" }}
                          ></i>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div style={{ padding: "1rem" }}>
                  <div className="mt-4 f14-700">About our Referral Program</div>

                  <div>
                    <div>
                      <div>
                        User to Business Referral Program - - On-board someone,
                        receive cash -
                      </div>
                      <div>
                        When you refer a business to us, we’ll see to it that
                        they successfully sign up and complete the necessary KYC
                        and other formalities. The moment they’re on-board,
                        we’ll reward you with money in the wallet.
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="mt-4 f14-700">
                    Terms and Conditions for Referral
                  </div>
                  <ul style={{ padding: "1rem" }}>
                    <li>Offer is valid for users on the App only </li>
                    <li>
                      We reserve the right to cancel/change/modify/add/delete
                      any of the terms and conditions of the offer at any time
                      without notice{" "}
                    </li>
                    <li>
                      We reserve the right to deny or honoring the offer on the
                      grounds of suspicion or abuse of the offer by any customer
                      without providing customer any explanation there of In no
                      event shall{" "}
                    </li>
                    <li>
                      Amealio is not liable for any abuse or misuse of the code
                      due to the negligence of the customer{" "}
                    </li>
                    <li>
                      The services shall be governed by the terms and conditions
                      set out here
                    </li>
                  </ul>
                  <div style={{ padding: "1rem" }}>
                    <div className="f12-500">
                      User to User - Refer and realize a dream - Refer a Friend{" "}
                    </div>
                    <div className="f12-400">
                      Every time you refer another user and they sign up and
                      place their first order/dine-in activity, we will donate
                      Rs. 50 on behalf of you! Your good actions have better
                      consequences, and we will carry it forward and ensure it’s
                      put to good use. Our Udbhav program makes it easier for
                      users to see real-world, actionable change to their
                      referrals and you can play your part in a small way.
                    </div>
                  </div>
                  <div class="d-flex align-items-center ">
                    <a
                      href={
                        state === 1
                          ? `https://devvendor.amealio.in/signup?referralCode=${props.referralcode}` // vendor sign up link
                          : `https://devvendor.amealio.in/signup?referralCode=${props.referralcode}` // user sign up link
                      }
                      target="_blank"
                    >
                      <button type="button" class="px-5  py-2 btn btn-danger">
                        Invite A Friend
                      </button>
                    </a>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
};

VendorReferrals.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  referrals: PropTypes.object.isRequired,
  logOutUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  referrals: state.vendorreferrals.vendorReferrals,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_referrals,
  logOutUser,
})(withRouter(VendorReferrals));
